import { useTranslation } from 'react-i18next'

import { Warning } from '@phosphor-icons/react'

import { Button, Modal } from '@reveni-io/reveni-ui'

import InfoFailedParcelsText from './InfoFailedParcelsText/InfoFailedParcelsText'
import ParcelLinks from './ParcelLinks/ParcelLinks'
import * as Styles from './styles'

const PrepareParcelsErrorModal = ({ show, onClose, failedParcels }) => {
  const { t } = useTranslation()

  return (
    <Modal
      title={
        <Styles.TitleContainer>
          <Warning size={24} weight="light" />
          {t('Error en la preparación de envíos')}
        </Styles.TitleContainer>
      }
      show={show}
      size="l"
      onClose={onClose}
    >
      <Styles.MainContainer>
        <InfoFailedParcelsText failedParcels={failedParcels} />
        <ParcelLinks parcels={failedParcels} />
        <Button onClick={onClose} fullWidth>
          {t('Entendido')}
        </Button>
      </Styles.MainContainer>
    </Modal>
  )
}

export default PrepareParcelsErrorModal
